import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "../backToTop";
import FooterThree from "@/components/Footer/Footer-Three";
import Link from "next/link";

const PrivacyPolicy = () => {
  return (
    <>
      <PageHead title="Privacy Policy - Immigration Guru's"
        description="How The Immigration Gurus collect, use, store and protect your personal information when you use our website and study abroad advisory services." />
      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <main
            className="container"
            style={{
              marginTop: "5rem",
            }}
          >
            <section>
              <h1 className="h4">PRIVACY POLICY</h1>
              <p>Last updated July 25, 2022</p>

              <div style={{ lineHeight: 1.5, color: "#7f7f7f" }}>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  This privacy notice for <strong>The Immigration Gurus</strong>{" "}
                  ("<strong>Company</strong>", "<strong>we</strong>", "
                  <strong>us</strong>", or "<strong>our</strong>") describes how
                  and why we might collect, store, use, and/or share ("
                  <strong>process</strong>") your information when you use our
                  services ("<strong>Services</strong>") such as when you:
                </p>

                <ul style={{ paddingLeft: "1.5rem", fontSize: "15px" }}>
                  <li>
                    Visit our website at{" "}
                    <a href="https://theimmigrationgurus.netlify.app/">
                      https://www.immigurus.com/
                    </a>
                    , or any website of ours that links to this privacy notice
                  </li>
                  <li>
                    Engage with us in other related ways, including any sales,
                    marketing, or events
                  </li>
                </ul>

                <p style={{ fontSize: "15px", color: "#595959" }}>
                  <bold>Questions or concerns?</bold> Reading this privacy
                  notice will help you understand your privacy rights and
                  choices. If you do not agree with our policies and practices,
                  please do not use our Services. If you still have any
                  questions or concerns, please contact us at
                  info@immigurus.com.
                </p>
              </div>
            </section>
            <section
              style={{
                marginTop: "3rem",
              }}
            >
              <h2 className="h4">SUMMARY OF KEY POINTS</h2>
              <div style={{ lineHeight: 1.5, color: "#7f7f7f" }}>
                <p
                  style={{
                    fontSize: "15px",
                    color: "#595959",
                    fontWeight: "bold",
                  }}
                >
                  This summary provides key points from our privacy notice, but
                  you can find out more details about any of these topics by
                  clicking the link following each key point or by using our
                  table of contents below to find the section you are looking
                  for. You can also go directly to our{" "}
                  <Link href="#table-of-contents">table of contents</Link>.
                </p>

                <p style={{ fontSize: "15px", color: "#595959" }}>
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    What personal information do we process?{" "}
                  </span>
                  When you visit, use, or navigate our Services, we may process
                  personal information depending on how you interact with The
                  Immigration Gurus and the Services, the choices you make, and
                  the products and features you use. See{" "}
                  <Link href="#what-information-do-we-collect">
                    what information we collect
                  </Link>
                  .
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    Do we process any sensitive personal information?
                  </span>
                  We do not process sensitive personal information.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    Do we receive any information from third parties?
                  </span>
                  We do not receive any information from third parties.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    How do we process your information?
                  </span>
                  We process your information to provide, improve, and
                  administer our Services, communicate with you, for security
                  and fraud prevention, and to comply with law. We may also
                  process your information for other purposes with your consent.
                  We process your information only when we have a valid legal
                  reason to do so.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    In what situations and with which parties do we share
                    personal information?
                  </span>
                  We may share information in specific situations and with
                  specific third parties.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    How do we keep your information safe?
                  </span>
                  We have organizational and technical processes and procedures
                  in place to protect your personal information. However, no
                  electronic transmission over the internet or information
                  storage technology can be guaranteed to be 100% secure, so we
                  cannot promise or guarantee that hackers, cybercriminals, or
                  other unauthorized third parties will not be able to defeat
                  our security and improperly collect, access, steal, or modify
                  your information.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    What are your rights?
                  </span>
                  Depending on where you are located geographically, the
                  applicable privacy law may mean you have certain rights
                  regarding your personal information.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  {" "}
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    How do you exercise your rights?
                  </span>
                  The easiest way to exercise your rights is by filling out our
                  data subject request form available here: __________, or by
                  contacting us. We will consider and act upon any request in
                  accordance with applicable data protection laws.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  Want to learn more about what The Immigration Gurus does with
                  any information we collect?
                </p>
              </div>
            </section>
            <section
              style={{
                marginTop: "3rem",
              }}
            >
              <h2 className="h4" id="table-of-contents">
                TABLE OF CONTENTS
              </h2>
              <ol>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  {" "}
                  WHAT INFORMATION DO WE COLLECT?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW DO WE PROCESS YOUR INFORMATION?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL
                  INFORMATION?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW DO WE HANDLE YOUR SOCIAL LOGINS?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW LONG DO WE KEEP YOUR INFORMATION?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW DO WE KEEP YOUR INFORMATION SAFE?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  {" "}
                  WHAT ARE YOUR PRIVACY RIGHTS?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  CONTROLS FOR DO-NOT-TRACK FEATURES
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  DO WE MAKE UPDATES TO THIS NOTICE?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                </li>
                <li
                  style={{
                    color: "#3030f1",
                    fontSize: "14px",
                    fontFamily: "Arial",
                    wordBreak: "break-word",
                  }}
                >
                  HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
                  YOU?
                </li>
              </ol>
            </section>
            <section
              style={{
                marginTop: "3rem",
              }}
            >
              <h2 className="h4" id="what-information-do-we-collect">
                1. WHAT INFORMATION DO WE COLLECT?
              </h2>
              <h3 className="h5">Personal information you disclose to us</h3>
              <div style={{ lineHeight: 1.5, color: "#7f7f7f" }}>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    In Short:
                  </span>{" "}
                  We collect personal information that you provide to us.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  We collect personal information that you voluntarily provide
                  to us when you register on the Services, express an interest
                  in obtaining information about us or our products and
                  Services, when you participate in activities on the Services,
                  or otherwise when you contact us.
                </p>
                <p style={{ fontSize: "15px", color: "#595959" }}>
                  <span
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Personal Information Provided by You.
                  </span>{" "}
                  The personal information that we collect depends on the
                  context of your interactions with us and the Services, the
                  choices you make, and the products and features you use. The
                  personal information we collect may include the following:
                </p>
              </div>
            </section>
          </main>

          <BackToTop />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default PrivacyPolicy;
